import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { user } from 'services';
import { notify } from 'libs/common';
import { Warning, themes } from 'libs/ui';
import { changeClientStatus } from 'services/client-service';
import { ToggleBox, Toggle, UpdateMessageStyled } from './client-activity.styled';

export const ClientActivity = (props) => {
  const { client, refresh } = props;
  const { t } = useTranslation();
  const [status, setStatus] = useState(client.status);
  const [warning, setWarning] = useState(false);
  const [updateMessage, setUpdateMessage] = useState(false);

  const rightChangeStatus = user.haveRight('clients.change_status');
  const isActive = status === 'active';

  /**
   * toggle client status with warning
   * @returns
   */
  const toggleStatus = () => {
    if (!rightChangeStatus) {
      return false;
    }

    if (isActive) {
      setWarning(true);
    } else {
      changeStatus();
    }
  };

  /**
   * set client status
   */
  const changeStatus = () => {
    const newStatus = isActive ? 'blocked' : 'active';
    changeClientStatus(client.id, newStatus)
      .then(() => {
        setStatus(newStatus);
        setUpdateMessage(true);
        refresh();
      })
      .catch((error) => notify('Изменение статуса', error.toString()));
  };

  /**
   * close warning
   */
  const closeWarning = () => {
    setWarning(false);
  };

  /**
   * get update msg text
   * @returns
   */
  const getMessage = () => {
    return isActive ? t('messages.Клиент успешно разблокирован') : t('messages.Клиент успешно заблокирован');
  };

  return (
    <>
      <ToggleBox isActive={isActive}>
        <p>{t('grid.Блокирован')}</p>
        <Toggle disabled={!rightChangeStatus} isActive={isActive} onClick={toggleStatus}>
          <div></div>
        </Toggle>
        <p>{t('grid.Активен')}</p>
      </ToggleBox>

      {warning && (
        <Warning
          width="540px"
          header={t('messages.Блокировка клиента')}
          mainText={{
            __html: `${t('messages.Блокировка клиента приведет к блокировке всех СО этого клиента')} </br>
                    ${t('messages.Заблокировать клиента')} ${client.name}?`,
          }}
          cancelButton={{
            func: closeWarning,
            text: t('buttons.Отменить'),
          }}
          acceptButton={{
            func: changeStatus,
            text: t('buttons.Заблокировать клиента'),
            img: '/images/icon_lock.png',
            theme: themes.red,
          }}
        />
      )}

      {updateMessage && <UpdateMessageStyled>{getMessage()}</UpdateMessageStyled>}
    </>
  );
};
